module.exports = __webpack_public_path__ + "assets/img/returnBtn-129659aa.png";